module.exports = __webpack_public_path__ + "img/jslc3.d45ab43b.png";